import './Pillar.css';
import React, { useState }  from "react";
import updateUserData from '../../../assets/functions/updateUserData'

function EditPillar(props) {
      const [pillarTitle, setPillarTitle] = useState(props.activePillar.title);
      const [glowPercent, setGlowPercent] = useState(props.activePillar.glowPercent);

      const handleTitleChange = (event) => {
        setPillarTitle(event.target.value);
      };

      const handleGlowChange = (event) => {
        setGlowPercent(event.target.value);
      };

      function resetPillarEdit() {
        props.setActivePillar(null)
      }

      function handleUpdatedPillar () {
        let placeholderPillar = {...props.activePillar}
        placeholderPillar.title=pillarTitle
        placeholderPillar.glowPercent=glowPercent
  
        let placeholderPillarList=[...props.userProfile.pillars]
        let indexToChange = placeholderPillarList.indexOf(props.activePillar)
        placeholderPillarList[indexToChange]=placeholderPillar
        updateUserData("updatePillars", placeholderPillarList, props.userProfile, props.setUserProfile, resetPillarEdit)
      }
  
      function handleDeletedPillar () {
        let deletedPillarPlaceholder = props.userProfile.pillars;
        const indexToDelete = deletedPillarPlaceholder.indexOf(props.activePillar);
        console.log(indexToDelete)
        if (indexToDelete > -1) {
          deletedPillarPlaceholder.splice(indexToDelete, 1);
        }
        console.log(deletedPillarPlaceholder)
        updateUserData("updatePillars", deletedPillarPlaceholder, props.userProfile, props.setUserProfile, resetPillarEdit)
      }

    return (
        <div className="editPillarPillar">
                <p> {"edit pillar: " + props.activePillar.title} </p>
          <div className="projectRow">
                <div >
                    <p className="addProjectTextHeader">pillar title</p>
                    <textarea
                    className="addUserInfoInputDiv"
                    type="text"
                    id="pillarTitle"
                    value={pillarTitle}
                    onChange={handleTitleChange}
                    name="projectTitle"
                    spellCheck="false"
                    />
                </div>
                <div>
                    <p className="addProjectTextHeader">glow percentage</p>
                    <input
                    className="addUserInfoNumberDiv"
                    type="number"
                    id="glowPercent"
                    value={glowPercent}
                    onChange={handleGlowChange}
                    name="glowPercent"
                    min="0" max="100"
                    />
                </div>
            </div>
            <div className="pillarButtonRow">
            <p className="pillarEditButton" onClick={() => handleUpdatedPillar()}> save edited pillar </p>
            <p className="pillarEditButton" onClick={() => handleDeletedPillar()}> delete this pillar </p>
            </div>
        </div>
    )
}

export default EditPillar;